export default "__VITE_PUBLIC_ASSET__1d18a9c3__"